import { DocumentSaveStatus } from 'components/editor/shared/models/DocumentSaveStatus';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import { useAppSelector } from 'components/editor/grid/reduxStore/Store';
import { selectCurrentSaveStatus } from 'components/editor/grid/reduxStore/saveStatusSlice';
import { saveStatusTestIds } from './SaveStatus.test-ids';

export default function SaveStatusText() {
  const { t } = useTranslation();
  const currentSaveStatus = useAppSelector(selectCurrentSaveStatus);

  return (
    <Typography
      className="save-status"
      variant="subtitle2"
      sx={{ color: (theme) => theme.palette.grey[700] }}
      data-testid={saveStatusTestIds.text}
    >
      {t(`document.save_statuses.${DocumentSaveStatus[currentSaveStatus.status]?.toLowerCase()}`)}
    </Typography>
  );
}
